<template>
    <div>
        <div class="alert alert-warning">
            This determines the amount of time until the same invitation can
            be sent to a contact. The minimum amount is 1 day.
        </div>
        <transition name="fade-in-down">
            <div class="row mt-4">
                <div class="col-3">
                    <label for="day">Number of:</label>
                    <input-text
                        :form="form"
                        field='day'
                        id="day"
                        placeholder="Enter a number"
                        type="number"
                        min="1"
                        v-model="form.day"
                    />
                </div>
                <div class="col-3">
                    <label for="period">&nbsp;</label>
                    <select id="period" class="custom-select" v-model="form.period">
                        <option value="day">day(s)</option>
                        <option value="week">week(s)</option>
                        <option value="month">month(s)</option>
                    </select>
                </div>
            </div>
        </transition>
        <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
            <button class="btn btn-default" type="button" data-dismiss="modal">
                Close
            </button>
            <button-loading type="button" class="btn btn-primary ml-2"
                :loading="form.submitting"
                @click="save">
                Save
            </button-loading>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['location'],

        data() {
            return {
                form: new Form(),
            }
        },

        watch: {
            location: {
                immediate: true,
                handler() {
                    if (this.location && this.location.period_invite) {

                        let data = this.location.period_invite.split(' ');

                        this.form = new Form({
                            location_id: this.location.id,
                            day        : data[0],
                            period     : data[1],
                        });

                        return;
                    }

                    this.form = new Form();
                }
            },
        },

        methods: {
            save() {
                return this.form.put(this.$laroute.route('location-period.update', {location: this.form.location_id}))
                    .then(({data}) => {
                        this.$emit('save-location', data.id);
                        swal.fire({
                            title: 'Location Saved!',
                            type: 'success',
                        })
                    }).catch(error => console.error(error));
            },
        }
    }
</script>

<style lang="scss" scoped>
    .alert {
        font-size: 0.8em;
    }
</style>
